import { getRecoilPromise } from "recoil-nexus";
import { authenticationTokenState } from "atoms/authenticationTokenState.atom";
import axios from "axios";

export const getAuthenticationToken = () => {
  return new Promise(async (resolve) => {
    getRecoilPromise(authenticationTokenState).then(function (authToken) {
      resolve("Bearer " + authToken);
    });
  });
};

export const apiPostFilesAxios = (url, documents) => {
  return new Promise(async function (resolve, reject) {
    const formData = new FormData();
    Array.from(documents).forEach((file) => {
      formData.append("files", file);
    });

    try {
      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      resolve(response);
    } catch (error) {
      console.error("Upload failed:", error);
      reject(error);
    }
  });
};

export const apiGetAxios = (url, bodyParam = null, contentType = "application/json") => {
  return new Promise(async function (resolve, reject) {
    try {
      const headers = {
        "Content-Type": contentType,
        Authorization: await getAuthenticationToken(),
      };

      const config = {
        method: "GET",
        url: url,
        headers: headers,
      };

      const response = await axios(config);
      resolve(response.data);
    } catch (err) {
      reject(err.response?.data || err.message);
    }
  });
};

export const apiGet = (url, bodyParam = null, contentType = "application/json") => {
  // WARNING: Please migrate your get calls to apiGetAxios instead going forward
  return new Promise(async function (resolve, reject) {
    const requestOptions = {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": contentType,
        Authorization: await getAuthenticationToken(),
      },
    };
    if (bodyParam !== null) {
      const bodyVar = {
        body: JSON.stringify(bodyParam),
      };
      Object.assign(requestOptions, bodyVar);
    }
    fetch(url, requestOptions)
      .then((response) => {
        response.json().then((json) => {
          if (response.ok) {
            resolve(json);
          } else {
            reject(json);
          }
        });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const apiPdfGet = (url) => {
  return new Promise(async function (resolve) {
    const response = await axios.get(url, {
      headers: {
        Accept: "application/octet-stream",
        "Content-Type": "application/pdf",
        Authorization: await getAuthenticationToken(),
      },
      responseType: "blob",
    });

    const file = new Blob([response.data], { type: "application/pdf" });
    // Build a URL from the file
    const fileURL = URL.createObjectURL(file);
    // Open the URL on new Window
    const pdfWindow = window.open();
    pdfWindow.location.href = fileURL;
    resolve(true);
  });
};

export const apiPost = (url, bodyParam = null, contentType = "application/json") => {
  return new Promise(async function (resolve, reject) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": contentType,
        Authorization: await getAuthenticationToken(),
      },
    };
    if (bodyParam !== null) {
      const bodyVar = {
        body: bodyParam,
      };
      Object.assign(requestOptions, bodyVar);
    }
    fetch(url, requestOptions)
      .then((response) => {
        response.json().then((data) => {
          const result = data;
          if (response.ok) {
            resolve(result);
          } else {
            reject(result);
          }
        });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const apiPut = (url, bodyParam = null, contentType = "application/json") => {
  return new Promise(async function (resolve, reject) {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": contentType,
        Authorization: await getAuthenticationToken(),
      },
    };
    if (bodyParam !== null) {
      const bodyVar = {
        body: bodyParam,
      };
      Object.assign(requestOptions, bodyVar);
    }
    fetch(url, requestOptions)
      .then((response) => {
        response.json().then((json) => {
          if (response.ok) {
            resolve(json);
          } else {
            reject(json);
          }
        });
      })
      .catch((err) => {
        reject(err);
      });
  });
};
